/* src/app/pages/whatsapp/whatsapp.component.css */
.IconoWhatsApp {
  position: fixed;
  bottom: 30px;
  right: 42px;
  z-index: 1000;
  text-decoration: none;
}
.whatsapp-container {
  display: flex;
  align-items: center;
}
.whatsapp-text {
  background-color: #5B6670;
  color: #FFFFFF;
  font-family: "Gotham Book", sans-serif;
  font-size: 14px;
  width: 119px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
  text-decoration: underline;
  text-decoration-color: #5B6670;
  margin-right: -12px;
}
.whatsapp-icon {
  width: 60px;
  height: 60px;
  background-color: #25D366;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: efecto 1.2s infinite;
}
@keyframes efecto {
  0% {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.4);
  }
  100% {
    box-shadow: 0 0 0 20px rgba(0, 0, 0, 0);
  }
}
/*# sourceMappingURL=/banorte/__host/inmuebles/Inmuebles/whatsapp.component.css.map */
